//神策埋点1.22.6
export default {
    //js私用属性
    trackData:{
    },
    //埋点公共属性
    publicData: {
        // platform_name: '',//平台名称-yaodianbao,gouyaopingtai,qita
        // is_login: false,
        // business_line_id: '',//业务线id-nice_drug,qita
    },
    setTrackData(data) {
        // this.trackData = {...this.trackData, ...data};
    },
    setPublicData(data) {
        // this.publicData = {...this.publicData, ...data};
        // sensors.registerPage(this.register());
    },
    /**
     *埋点公共数据
     */
    register() {
        // return {
        //     ...this.publicData,
        // };
    },
    clearAllRegister(){
        // sensors.clearAllRegister();
    },
    registerPage() {
        // 公共数据 静态公共属性
        // sensors.registerPage(this.register());
    },
    /**
     * 触发埋点方法
     * @param type 事件名称
     * @param params 自定义字段
     */
    send(type, params) {
        // sensors.track(type, params);
    },

    /**
     * 使用 sensors.login 完成用户标识的注册
     * @param memberId
     */
    sendLogin(memberId) {
        // sensors.login(memberId);
        // return [memberId]
    },

    /**
     * 使用 sensors.logout 切换到之前的匿名 id
     */
    logout() {
        // sensors.logout();
    },


    getAnonymousID2() {
        // return new Promise((resolve => {
        //     sensors.quick('isReady', function () {
        //         resolve(sensors.quick('getAnonymousID'));
        //     });
        // }))
    },
    getAnonymousID() {
        // return sensors.quick('getAnonymousID')
    }
}

